export default "__VITE_ASSET__b55d1849__"